import { lazy } from 'react';

const retry = (dynamicImport, retriesLeft = 5, interval = 500) =>
  new Promise((resolve, reject) => {
    dynamicImport()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }

          retry(dynamicImport, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });

function lazyLoadWithRetry(dynamicImport) {
  return lazy(() => retry(dynamicImport));
}

let lazyImport = lazy;
if (process.env.NODE_ENV === 'production') {
  lazyImport = lazyLoadWithRetry;
}

export { lazyImport };
